import React from 'react';
import { Card } from '../card/Card.view';

export const SubscriptionCard: React.FC<{
  onClick: () => void;
  actions: React.ReactNode;
  asideActions?: React.ReactNode;
  badges?: Record<string, string>;
  testid?: string;
  description: string;
  type: 'success' | 'default';
  avatar?: React.ReactNode;
}> = ({ onClick, actions, asideActions, badges, description, type, avatar, testid }) => (
  <Card
    actions={actions}
    asideActions={asideActions}
    badges={badges}
    header={avatar}
    onClick={onClick || null}
    text={description}
    type={type}
    testid={testid}
  />
);
